import React from "react";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import "../Newsfeed.css";
import { ArticleImage } from "../NewsfeedInterfaces";


type SlideshowProps = {
    images: ArticleImage[],
}


const Slideshow: React.FC<SlideshowProps> = ({ images }: SlideshowProps) => {
    return (

        <Swiper
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}
            autoHeight={true}
            className="newsSlider"
        >
            {images.map((step) => (
                <SwiperSlide key={step.id}>
                    <img
                        src={step.img}
                        alt={step.text}
                        height="auto"
                        width="100%"
                        loading="lazy"
                    />
                    {step.caption && step.caption !== '' && <p className={'image-caption'}>{step.caption}</p>}
                </SwiperSlide>
            ))}
        </Swiper>
    )
}

export default Slideshow;